import { Injectable } from '@angular/core';
import { ManualApiService } from '@core/api/services/manual-api.service';
import { Pageable } from '@core/pagination/pageable';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ManualListItem } from '../models/manual/manual-list-item';
import { switchMap } from 'rxjs/operators';
import { ManualListAdapter } from '../adapters/manual-list.adapter';
import { ManualAdapter } from '../adapters/manual.adapter';
import { PageableFactory } from '@core/pagination/pageable.factory';
import { Manual } from '../models/manual/manual';
import { ArticleListItem } from '../models/article/article-list-item';
import { ManualSearchResult } from '../models/manual/manual-search-result';
import { ManualSearchAdapter } from '../adapters/manual-search.adapter';

@Injectable({
  providedIn: 'root'
})
export class ManualService {

  constructor(
    private manualApiService:ManualApiService,
    private manualListAdapter:ManualListAdapter,
    private manualAdapter:ManualAdapter,
    private manualSearchAdapter:ManualSearchAdapter,
  ) { }


  manual: BehaviorSubject<Manual|null> = new BehaviorSubject<Manual|null>(null);


  getManuals(criteria: any, page: number): Observable<Pageable<ManualListItem>> {
    const params: Record<string, string> = {};

    if (criteria.searchTerm.length) {
      params['search'] = criteria.searchTerm;
    }

    if (criteria.language) {
      params['language.isoCode'] = criteria.language;
    }

    params['page'] = page.toString();
    params['order[title]'] = 'asc';

    return this.manualApiService.getResourceCollection(params).pipe(
      switchMap(async collection => PageableFactory.createFromCollectionStatic<ManualListItem>(collection, this.manualListAdapter)))
  }

  getManual(id: string){
     return this.manualApiService.get(id).subscribe((x) => { this.manual.next(this.manualAdapter.adapt(x))});
  }
  getManualBySlug(slug: string){
     return this.manualApiService.getBySlug(slug).subscribe((x) => { this.manual.next(this.manualAdapter.adapt(x))});
  }

  clear(){
    this.manual.next(null);
  }

  openTree(id:string){
    const manual =  this.manual.value;
    if(manual){
      this.checkChildren(manual.articles,id);
    }
  }

  checkChildren(articleItems:ArticleListItem[] ,id:string){
        
    for (const item of articleItems) {
      if (item.slug === id) {
        
          return item;
      }

      const foundInChild:any = this.checkChildren(item.children,id);
      if (foundInChild) {
          item.open = true;
          return foundInChild;
      }
    }
    return null;
  }

  searchManual(id:string,criteria: any, page: number): Observable<Pageable<ManualSearchResult>> {

    const params: Record<string, string> = {};

    if (criteria.searchTerm.length) {
      params['query'] = criteria.searchTerm;
    }

    params['page'] = page.toString();
  
    return this.manualApiService.search(id,criteria.searchTerm).pipe(
      switchMap(result =>  {return of(new Pageable<ManualSearchResult>(result.map((x:any) =>this.manualSearchAdapter.adapt(x)),1,1,result.length))})
    )
  }
}
